import { FormControl, FormGroup } from '@angular/forms'

export class FormUtils {
  public static markFieldsAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field)
      if (control instanceof FormControl) {
        control.markAsTouched()
        control.updateValueAndValidity()
      }
    })
  }

  public static isFormEmpty(formGroup: FormGroup): boolean {
    return Object.values(formGroup.getRawValue()).every((value) => !value)
  }
}
